import { ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";

const SCENARIOS = [
  {
    q: "Masz kapitał i szukasz projektu?",
    a: "Wyszukam nieruchomość, przeanalizuję jej potencjał i przygotuję koncepcję inwestycji.",
    value: "Mam kapitał — szukam projektu inwestycyjnego",
  },
  {
    q: "Masz grunt?",
    a: "Sprawdźmy, jak wykorzystać jego potencjał i zwiększyć jego wartość.",
    value: "Mam grunt — chcę zwiększyć jego wartość",
  },
  {
    q: "Rozwijasz sieć?",
    a: "Mogę zostać Twoim regionalnym partnerem odpowiedzialnym za pozyskiwanie nowych lokalizacji.",
    value: "Rozwijam sieć — szukam lokalizacji",
  },
  {
    q: "Masz projekt, ale nie chcesz prowadzić go sam?",
    a: "Mogę przejąć koordynację całego procesu inwestycyjnego.",
    value: "Szukam partnera do prowadzenia projektu",
  },
];

export const Scenarios = ({ onSelect }) => {
  const pick = (value) => {
    onSelect(value);
    document.querySelector("#kontakt")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section data-testid="scenarios-section" className="bg-white py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
        <Reveal className="mb-14">
          <p className="mb-4 font-mono text-xs font-semibold uppercase tracking-[0.2em] text-[#8C6D46]">
            Zacznijmy od Twojej sytuacji
          </p>
          <h2 className="font-serif text-2xl font-semibold leading-tight tracking-tight text-slate-950 sm:text-3xl lg:text-4xl">
            Który scenariusz opisuje Cię najlepiej?
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 gap-px overflow-hidden rounded-sm border border-slate-200 bg-slate-200 sm:grid-cols-2">
          {SCENARIOS.map((s, i) => (
            <button
              key={s.value}
              data-testid={`scenario-card-${i + 1}`}
              onClick={() => pick(s.value)}
              className="group flex h-full flex-col justify-between bg-white p-8 text-left transition-colors duration-300 hover:bg-[#FAF6F0] lg:p-10"
            >
              <div>
                <h3 className="font-serif text-xl font-medium leading-snug text-slate-900 sm:text-2xl">
                  {s.q}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-slate-600">{s.a}</p>
              </div>
              <span className="mt-8 flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.18em] text-[#8C6D46]">
                Porozmawiajmy
                <ArrowRight size={14} className="transition-transform duration-300 group-hover:translate-x-1" />
              </span>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
};
